import { api } from "./apiClient";

export const knowledgeBaseAPI = {
  list: (projectId) =>
    api.get(`/projects/${projectId}/kb-intake`, { timeout: 90000 }),
  options: (projectId) =>
    api.get(`/projects/${projectId}/kb-intake/options`, { timeout: 90000 }),
  classify: (projectId, intakeId) =>
    api.post(`/projects/${projectId}/kb-intake/${intakeId}/classify`, null, {
      timeout: 240000,
    }),
  updateClassification: (projectId, intakeId, payload) =>
    api.patch(
      `/projects/${projectId}/kb-intake/${intakeId}/classification`,
      payload,
    ),
  accept: (projectId, intakeId, payload) =>
    api.post(`/projects/${projectId}/kb-intake/${intakeId}/accept`, payload),
  reject: (projectId, intakeId, payload) =>
    api.post(`/projects/${projectId}/kb-intake/${intakeId}/reject`, payload),
  sync: (projectId, intakeId) =>
    api.post(`/projects/${projectId}/kb-intake/${intakeId}/sync`),
  refresh: (projectId, intakeId) =>
    api.post(`/projects/${projectId}/kb-intake/${intakeId}/refresh`, null, {
      timeout: 60000,
    }),
  backfill: (projectId) =>
    api.post(`/projects/${projectId}/kb-intake/backfill`, null, {
      timeout: 60000,
    }),
};
